<!-- 官网：https://www.wangeditor.com/v5/for-frame.html#%E9%85%8D%E7%BD%AE-1 -->
<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editorRef"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 500px; overflow-y: hidden;"
      v-model="selectValue"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="handleCreated"
      @customPaste="customPaste"
    />
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted, computed } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { OssUploadFile } from 'utils/oss.js'
import { isStringEmpty } from 'utils/utils'
export default {
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef()

    // 内容 HTML
    const valueHtml = ref(null)

    onMounted(() => {
      console.log(editorRef.value, 'editorRef')
    })

    const toolbarConfig = {}
    const editorConfig = {
      placeholder: '请输入内容...',
      MENU_CONF: {
        maxFileSize: 500 * 1024 * 1024, // 500M
        allowedFileTypes: ['image/*'],
        // 自定义插入图片
        uploadImage: {
          customUpload(file, insertFn) {
            uploadFile(file, insertFn)
          }
        }
      }
    }

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })
    /**
     * 计算双向绑定的值
     */
    const selectValue = computed({
      get() {
        return !isStringEmpty(props.value) ? props.value : undefined
      },
      set(value) {
        emit('update:value', value)
      }
    })

    const handleCreated = editor => {
      console.log(editor, 'editor')
      editorRef.value = editor // 记录 editor 实例，重要！
      valueHtml.value = props.htmlvalue
    }
    /**
     * 处理图片上传
     * @returns
     */
    const customPaste = (editor, event) => {
      if (
        event.clipboardData &&
        event.clipboardData.files &&
        event.clipboardData.files.length
      ) {
        handlerChange(event.clipboardData.files)
      }
      const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
      if (text) {
        editor.insertText(text)
      }

      // 阻止默认的粘贴行为
      event.preventDefault()
      return false
    }

    const insertImage = (url, alt, href) => {
      const node = {
        type: 'image',
        src: url,
        alt,
        href,
        children: [{ text: '' }]
      }
      editorRef.value.insertNode(node)
    }

    const getOssRegion = () => {
      if (process.env.VUE_APP_MODE === 'production') {
        return 'oss-accelerate'
      }
      return 'oss-cn-hangzhou'
    }
    const replaceURL = url => {
      if (process.env.VUE_APP_MODE === 'production') {
        return url.replace(
          'cs-scm.oss-accelerate.aliyuncs.com',
          'oss-scm-prod.kapeixi.cn'
        )
      }
      return url
    }
    const uploadFile = async file => {
      const region = getOssRegion()

      const oss = OssUploadFile.getInstance(region)

      const result = await oss.put(file).catch(() => {
        return null
      })
      const url = replaceURL(result.res.requestUrls[0])
      insertImage(url, '', url)
    }
    const handlerChange = files => {
      files.forEach(file => {
        uploadFile(file)
      })
    }
    const setValue = val => {
      valueHtml.value = val
    }

    return {
      editorRef,
      valueHtml,
      mode: 'simple', // 或 'simple'
      toolbarConfig,
      editorConfig,
      handleCreated,
      setValue,
      selectValue,
      customPaste
    }
  }
}
</script>
<style lang="scss">
.w-e-full-screen-container {
  z-index: 9999;
}
</style>
